import {
    // IconButton,
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    // TablePagination,
    TableRow,
    TableSortLabel,
    // Tooltip,
} from '@material-ui/core';
import React, { useState } from 'react';
// import ButtonComp from '../../components/button';
// import ListIcon from '@material-ui/icons/List';
// import FormDialog from '../../../../components/table/FormDialog';
// import CommentDeleting from '../OpenService/CommentDeleting';
import '../services/servicestyles.css';
// import OpenService from '../services/view/OpenService';
import './indexStyles.css';

function EnhancedTableHead(props) {
    const { classes, headcells, order, orderBy, onRequestSort, action } = props;

    const createSortHandler = (property) => (event) => {
        //console.log("hearderID", property);
        onRequestSort(event, property);
    };
    return (
        <TableHead size="medium" className={classes.thead}>
            <TableRow>
            <TableCell className={classes.TableHeadCss} >SL No</TableCell>
                {headcells.map((headRow) => {
                    return (
                        <TableCell
                            className={classes.TableHeadCss}
                            key={headRow.id}
                            align="left"
                            sortDirection={orderBy === headRow.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headRow.id}
                                direction={orderBy === headRow.id ? order : 'asc'}
                                onClick={createSortHandler(headRow.id)}
                            >
                                {headRow.label}
                                {orderBy === headRow.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}{' '}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}

                {/* {action && (
                    <TableCell align="center" className={classes.TableHeadCss}>
                        {' '}
                        Action
                    </TableCell>
                )} */}
            </TableRow>
        </TableHead>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    thead: {
        fontSize: 16,
        backgroundColor: 'gainsboro',
    },
    tableRow: {
        height: '50px',
    },
    TableHeadCss: {
        fontWeight: '700',
        fontFamily: 'Lato',
        fontSize: '14px',
        color: '#31333F',
        backgroundColor: '#dcdcdc',
    },
    red: {
        backgroundColor: 'red',
        color: 'white',
        borderRadius: '3px',
        padding: '3px 10px',
        textTransform: 'capitalize',
        fontFamily: 'Lato',
    },
    green: {
        backgroundColor: 'green',
        color: 'white',
        borderRadius: '3px',
        padding: '3px 6px',
        textTransform: 'capitalize',
        fontFamily: 'Lato',
    },
    grey: {
        backgroundColor: 'grey',
        color: 'white',
        borderRadius: '3px',
        padding: '3px 6px',
        textTransform: 'capitalize',
        fontFamily: 'Lato',
    },
    cellhide: {
        display: 'none',
        // "&:hover": {
        //     display: "block"
        //   }
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

function descendingComparator(a, b, orderBy) {
    //console.log(a, b, " From descending Comparator");
    //console.log(typeof (a[orderBy]), b[orderBy], " From descending Comparator");

    const x = typeof a[orderBy] === 'string' ? a[orderBy].toLowerCase() : a[orderBy];
    const y = typeof b[orderBy] === 'string' ? b[orderBy].toLowerCase() : b[orderBy];

    if (y < x) {
        return -1;
    }
    if (x > y) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    //console.log(stabilizedThis, "stableThis");

    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => {
        //console.log(el[0], "innerElement");
        return el[0];
    });
}

const OpenTable = (props) => {
    const { headcells, action, rows, service, pageName, handleClickOpen } = props; // need to remove
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    // Styles
    const classes = useStyles();

    // SOrting data

    const handleRequestSort = (event, property) => {
        //console.log("RequestedPropert", property);
        //console.log("asc",order , orderBy);
        const isAsc = orderBy === property && order === 'asc';
        //console.log(isAsc, " IsAsc*****");
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // handling Row Data after slice

    const rowData = (rowdata, serviceType) => {
        return headcells.map((col) => {
            let tabledata;
            const ravi = rowdata.statusId;
            //console.log(ravi, 'ravi from status ID');
            if (col.id === 'statusId' && ravi[col.id] === 5) {
                tabledata = (
                    <TableCell style={{ fontFamily: 'Lato' }} align="left">
                        <span className={classes.red}> {ravi.statusText} </span>
                    </TableCell>
                );
            } else if (col.id === 'statusId' && ravi[col.id] === 2) {
                tabledata = (
                    <TableCell style={{ fontFamily: 'Lato' }} align="left" key={col.id}>
                        <span className={classes.green}> {ravi.statusText} </span>
                    </TableCell>
                );
            } else if (col.id === 'statusId' && ravi[col.id] === 3) {
                tabledata = (
                    <TableCell style={{ fontFamily: 'Lato' }} align="left" key={col.id}>
                        <span className={classes.grey}> {ravi.statusText} </span>
                    </TableCell>
                );
            } else if (col.id === 'statusId' && serviceType === 'open' && ravi[col.id] === 1) {
                tabledata = (
                    <TableCell style={{ fontFamily: 'Lato' }} align="left" key={col.id}>
                        <button className="checklistBtn-openService"> Generate Checklist </button>
                    </TableCell>
                );
            } else if (col.id === 'statusId' && serviceType === 'open' && ravi[col.id] !== 1) {
                tabledata = (
                    <TableCell style={{ fontFamily: 'Lato' }} align="left" key={col.id}>
                        <span> {ravi.statusText} </span>
                    </TableCell>
                );
            } else {
                if (col.isConcat && rowdata[col.id]) {
                    const subdata = rowdata[col.id];
                    const mergedData = col.concatElem.map((concatdata) => {
                        return concatdata.split('.').reduce((acc, item) => {
                            if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                return acc[item];
                            }
                            return '';
                        }, subdata);
                    });
                    return (
                        <TableCell style={{ fontFamily: 'Lato' }} align="left" key={col.id}>
                            {mergedData.join(' ')}
                        </TableCell>
                    );
                }
                tabledata = (
                    <TableCell style={{ fontFamily: 'Lato' }} align="left" key={col.id}>
                        {rowdata[col.id]}
                    </TableCell>
                );
            }

            return tabledata;
        });
    };

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <TableContainer>
                    <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table" size="medium">
                        <EnhancedTableHead
                            classes={classes}
                            headcells={headcells}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            action={action}
                        />

                        <TableBody style={{ fontFamily: 'Lato' }}>
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    //console.log("FilteredRow", row);
                                    //console.log("order", order);
                                    //console.log("orderBy", orderBy)
                                    const rowDataShow = rowData(row, service);
                                    let slno = 1;
                                    if (page > 0) {
                                        slno = rowsPerPage * page + 1;
                                    }
                                    slno += index;

                                    return (
                                        <TableRow hover tabIndex={-1} key={slno} className={classes.tableRow}>
                                            <TableCell style={{ fontFamily: 'Lato' }}>{slno}</TableCell>
                                            {rowDataShow}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className="dashboardbtndiv">
                    <div className="dashboarddiv">
                        {/* <ButtonComp type="submit" className="butn" title="Open Service" /> */}
                        <button type="button" className="btn" onClick={handleClickOpen}>
                            Open Service
                        </button>
                    </div>
                </div>
            </Paper>
        </div>
    );
};

export default OpenTable;
